import { render } from "./App.vue?vue&type=template&id=2db31c90"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2db31c90&lang=css"

import exportComponent from "/Users/jon/Documents/2022/10000_views_of_mt_toro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__